import graphql from "babel-plugin-relay/macro";
import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { useFragment } from "react-relay";

import { useInitGroupEvent_event$key } from "./__generated__/useInitGroupEvent_event.graphql";
import { EventGroupData, groupEventAtom } from "./groupEvent";

export const useInitGroupEvent = ({
  fragmentRef,
}: {
  fragmentRef: useInitGroupEvent_event$key | null;
}) => {
  const setIsGroupEventData = useSetAtom(groupEventAtom);
  const data = useFragment(useInitGroupEventFragmentString, fragmentRef);

  useEffect(() => {
    if (data) {
      const allowedGroupSizes =
        data?.allowedGroupSizes.map((s) => s ?? null) || [];
      const groupEventData: EventGroupData = {
        maxMemberCount: data?.maxMemberCount,
        minMemberCount: data?.minMemberCount,
        maxGuestCount: data?.maxGuestCount,
        minGuestCount: data?.minGuestCount,
        allowedGroupSizes,
      };
      setIsGroupEventData({ ...groupEventData });
    }
  }, [data, setIsGroupEventData]);
};

export const useInitGroupEventFragmentString = graphql`
  fragment useInitGroupEvent_event on Event {
    maxMemberCount
    minMemberCount
    maxGuestCount
    minGuestCount
    allowedGroupSizes
  }
`;
